module.exports = __webpack_public_path__ + "img/song_title.d9fa053f.png";